import React, { useEffect, useState } from "react";
import { getStaff_geoTagList_fromDataBase } from "../CrudOperations/GetOperation";
import baseurl from "../CrudOperations/customURl";

const StafGeoTagList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [GetStaffGet_TagLists, setGetStaffGet_TagLists] = useState([]);

  const [selectedMedia, setSelectedMedia] = useState(null);
  const [selectedType, setSelectedType] = useState("");

  useEffect(() => {
    const fetchStaffs = async () => {
      const response = await getStaff_geoTagList_fromDataBase();

      console.log(response);

      if (response.data.Message === "Success") {
        setGetStaffGet_TagLists(response.data.Data);
      }
    };
    fetchStaffs();
  }, []);

  const handleSearchInput = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredList = GetStaffGet_TagLists.filter(
      (p) =>
        p.StaffName.toLowerCase().includes(query) ||
        p.SkillName.toLowerCase().includes(query)
    );

    setGetStaffGet_TagLists(filteredList);
  };

  return (
    <div className="container mx-auto p-8 bg-white rounded-lg shadow-lg shadow-gray-300">
      <h1 className="text-xl font-inter font-bold mb-6 border-b-4 border-blue-600 pb-2 text-gray-800">
        Geo Tag List
      </h1>

      <div className="mb-6 flex justify-between items-center">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInput}
          className="w-1/2 border border-gray-300 p-3 rounded-md transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
        />
      </div>

      {/* Responsive table wrapper */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white table-auto border border-gray-300 rounded-lg shadow-sm">
          <thead className="bg-gray-100">
            <tr>
              {[
                "S.No",
                "Deputy Name",
                "Loaction",
                "Media Type",
                "Media",
                "Created On",
              ].map((heading) => (
                <th
                  key={heading}
                  className="py-3 px-4 text-center font-semibold text-gray-700"
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {console.log(GetStaffGet_TagLists)}

            {GetStaffGet_TagLists.length > 0 ? (
              GetStaffGet_TagLists.map((p, index) => (
                <tr
                  key={p.GeoTagId}
                  className="border-b transition-colors duration-200 hover:bg-gray-50"
                >
                  <td className="py-3 px-4 text-center">{index + 1}</td>
                  <td className="py-3 px-4 text-center">{p.StaffName}</td>
                  <td className="py-3 px-4 text-center">
                    <a
                      href={`https://www.google.com/maps?q=${p.Latitude},${p.Longitude}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline flex items-center justify-center gap-1"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-red-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 11c1.656 0 3-1.343 3-3s-1.344-3-3-3-3 1.343-3 3 1.344 3 3 3z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 2C8.134 2 5 5.134 5 9c0 6 7 13 7 13s7-7 7-13c0-3.866-3.134-7-7-7z"
                        />
                      </svg>
                      View
                    </a>
                  </td>

                  <td className="py-3 px-4 text-center">{p.MediaType}</td>
                  <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => {
                        setSelectedMedia(p.Media);
                        setSelectedType(p.MediaType);
                      }}
                      className="text-blue-600 hover:underline"
                    >
                      View Media
                    </button>
                  </td>
                  <td className="py-3 px-4 text-center">
                    {new Date(p.CreatedOn)
                      .toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })
                      .replace(",", " at")}
                  </td>
                </tr>
              ))
            ) : (
              <tr key={"unique-key"}>
                <td colSpan="9" className="py-3 text-center text-gray-600">
                  No Staffs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {selectedMedia && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow-lg max-w-md w-full relative">
            <button
              className="absolute top-2 right-3 text-red-500 text-xl"
              onClick={() => setSelectedMedia(null)}
            >
              ×
            </button>

            {selectedType === "image" ? (
  <img
    src={`https://dlapi.wipenex.com/${selectedMedia}`}
    alt="Media"
    className="w-96 h-96 rounded"
  />
) : selectedType === "video" ? (
  <video controls className="rounded w-96 h-96">
    <source src={`https://dlapi.wipenex.com/${selectedMedia}`} type="video/mp4" />
    Your browser does not support the video tag.
  </video>
) : (
  <p>Unsupported media type</p>
)}

          </div>
        </div>
      )}
    </div>
  );
};

export default StafGeoTagList;
